/**
 * Free-gift swap in ns-hybrid-cart (classic script, deferred after <ns-hybrid-cart>).
 * Handles: #koh-gift-products-handles-cart, #koh-gift-products-handles, ns-hybrid-cart-config.settings.koh_gift_swap_products, bundle-builder-config.
 */
;(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (window.__KOH_GIFT_SWAP_INIT__) return
  window.__KOH_GIFT_SWAP_INIT__ = true

  var NOTE_TAG = '[KOH_FREE_GIFT]:'

  function giftNotePrefix() {
    var name = window.Shopify && window.Shopify.theme && window.Shopify.theme.name
    if (typeof name === 'string' && name.trim()) return name.trim() + ' --- [KOH_FREE_GIFT]:'
    return '[KOH_FREE_GIFT]:'
  }
  var SLEEP_PRODUCT_ID = 9012566261978
  var DEFAULT_GIFT_PRODUCT_ID = 8995801989338
  var KNOWN_GIFT_HANDLES = {
    'included-kreature-kontainer-glass': 1,
    'glass-cup': 1,
    'glass-jar': 1,
    'glass-mug': 1,
  }
  var CART_CACHE_TTL_MS = 3000
  var cachedCart = null
  var cachedCartAt = 0
  var cartRequestInFlight = null

  function shopRoot() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    return typeof r === 'string' && r.length ? r : '/'
  }

  function safeParse(value) {
    try {
      return JSON.parse(value)
    } catch (e) {
      return null
    }
  }

  function imageResizeUrl(url, w, h) {
    if (!url) return ''
    var sep = url.indexOf('?') >= 0 ? '&' : '?'
    return url + sep + 'width=' + w + '&height=' + h + '&crop=center'
  }

  function getRoots() {
    var roots = []
    var cartEl = document.getElementById('ns-hybrid-cart')
    var wrapper = document.getElementById('ns-hybrid-cart-wrapper')
    var ce = document.querySelector('ns-hybrid-cart')
    if (ce && ce.shadowRoot) roots.push(ce.shadowRoot)
    if (cartEl) roots.push(cartEl)
    if (wrapper) roots.push(wrapper)
    if (cartEl && cartEl.shadowRoot) roots.push(cartEl.shadowRoot)
    roots.push(document)
    return roots
  }

  function getStoredGifts() {
    var raw = localStorage.getItem('koh_available_gifts')
    var parsed = safeParse(raw)
    return Array.isArray(parsed) ? parsed.filter(function (g) { return g && typeof g === 'object' }) : []
  }

  function getSelectedGift() {
    return safeParse(localStorage.getItem('koh_selected_gift')) || null
  }

  function persistGifts(gifts) {
    if (!Array.isArray(gifts) || !gifts.length) return
    try {
      localStorage.setItem('koh_available_gifts', JSON.stringify(gifts.slice(0, 2)))
      window.dispatchEvent(new CustomEvent('koh-gifts-updated'))
    } catch (e) {}
  }

  function persistSelectedGift(gift) {
    if (!gift || !gift.title) return
    try {
      localStorage.setItem(
        'koh_selected_gift',
        JSON.stringify({
          handle: gift.handle || '',
          title: gift.title,
          image: gift.image || '',
          description: gift.description || 'with subscription',
        })
      )
      localStorage.removeItem('koh_skip_gift')
    } catch (e) {}
  }

  function giftHandlesMatch(stored, handles) {
    if (!stored.length || !handles.length) return false
    var set = Object.create(null)
    for (var i = 0; i < handles.length; i++) set[handles[i]] = 1
    for (var j = 0; j < stored.length; j++) {
      var h = stored[j] && stored[j].handle
      if (!h || !set[h]) return false
    }
    return true
  }

  function seedSelectedGiftFromAvailable(gifts) {
    if (!gifts || !gifts.length) return
    var selected = getSelectedGift()
    var handleSet = Object.create(null)
    for (var i = 0; i < gifts.length; i++) {
      if (gifts[i] && gifts[i].handle) handleSet[gifts[i].handle] = gifts[i]
    }
    // Keep selection only if it still matches a current customizer gift.
    if (selected && selected.handle && handleSet[selected.handle]) {
      var matched = handleSet[selected.handle]
      if (!selected.image && matched.image) {
        persistSelectedGift(matched)
      }
      return
    }
    persistSelectedGift(gifts[0])
  }

  function addHandle(seen, out, h) {
    if (typeof h !== 'string' || !h.length) return
    if (h.indexOf('gid://') === 0) return
    if (seen[h]) return
    seen[h] = 1
    out.push(h)
  }

  function handlesFromJsonScript(id) {
    var el = document.getElementById(id)
    if (!el || !el.textContent) return []
    var arr = safeParse(el.textContent)
    return Array.isArray(arr) ? arr : []
  }

  /** Theme editor product_list in section JSON is often objects with handle (or GIDs as strings — skipped). */
  function handlesFromCartSectionSettings() {
    var el = document.getElementById('ns-hybrid-cart-config')
    if (!el || !el.textContent) return []
    var cfg = safeParse(el.textContent)
    var raw = cfg && cfg.settings && cfg.settings.koh_gift_swap_products
    if (!Array.isArray(raw)) return []
    var out = []
    for (var i = 0; i < raw.length; i++) {
      var item = raw[i]
      if (typeof item === 'string') {
        if (item.indexOf('Product/') === -1) out.push(item)
      } else if (item && typeof item === 'object' && item.handle) {
        out.push(String(item.handle))
      }
    }
    return out
  }

  function handlesFromBundleConfig() {
    var el = document.getElementById('bundle-builder-config')
    if (!el || !el.textContent) return []
    var cfg = safeParse(el.textContent)
    var raw = cfg && cfg.settings && cfg.settings.gift_products
    if (!Array.isArray(raw)) return []
    var out = []
    for (var i = 0; i < raw.length; i++) {
      var item = raw[i]
      if (typeof item === 'string') {
        if (item.indexOf('Product/') === -1) out.push(item)
      } else if (item && item.handle) {
        out.push(String(item.handle))
      }
    }
    return out
  }

  function readGiftHandlesFromDom() {
    var seen = {}
    var out = []
    handlesFromJsonScript('koh-gift-products-handles-cart').forEach(function (h) {
      addHandle(seen, out, h)
    })
    handlesFromJsonScript('koh-gift-products-handles').forEach(function (h) {
      addHandle(seen, out, h)
    })
    handlesFromCartSectionSettings().forEach(function (h) {
      addHandle(seen, out, h)
    })
    handlesFromBundleConfig().forEach(function (h) {
      addHandle(seen, out, h)
    })
    return out.slice(0, 2)
  }

  function ensureGifts(cb) {
    var handles = readGiftHandlesFromDom()
    var current = getStoredGifts()

    // Re-fetch whenever customizer handles changed (or cache is empty / missing images).
    var needsRefresh =
      handles.length > 0 &&
      (!giftHandlesMatch(current, handles) ||
        current.some(function (g) {
          return !g || !g.image
        }))

    if (!needsRefresh && current.length >= 1) {
      seedSelectedGiftFromAvailable(current)
      cb(current)
      return
    }

    if (handles.length < 1) {
      seedSelectedGiftFromAvailable(current)
      cb(current)
      return
    }

    var root = shopRoot()
    Promise.all(
      handles.map(function (handle) {
        return fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
          .then(function (r) {
            return r.ok ? r.json() : null
          })
          .catch(function () {
            return null
          })
      })
    ).then(function (products) {
      var gifts = products
        .filter(Boolean)
        .map(function (product) {
          var image = product.featured_image || ''
          if (image && typeof image === 'object') {
            image = image.src || image.url || ''
          }
          return {
            handle: product.handle,
            title: product.title,
            image: image,
            description: 'with subscription',
          }
        })
      if (gifts.length >= 1) {
        persistGifts(gifts)
        seedSelectedGiftFromAvailable(gifts)
        cb(gifts)
        return
      }
      seedSelectedGiftFromAvailable(current)
      cb(current)
    })
  }

  function getSwapGift() {
    var selected = getSelectedGift()
    var gifts = getStoredGifts()
    if (gifts.length < 2) return null
    if (selected && selected.handle) {
      for (var i = 0; i < gifts.length; i++) {
        if (gifts[i].handle && gifts[i].handle !== selected.handle) return gifts[i]
      }
    }
    if (selected && selected.title) {
      for (var j = 0; j < gifts.length; j++) {
        if (gifts[j].title && gifts[j].title !== selected.title) return gifts[j]
      }
    }
    return gifts[1] || null
  }

  function getPrimaryGift() {
    var selected = getSelectedGift()
    if (selected && selected.title) return selected
    var gifts = getStoredGifts()
    return gifts.length ? gifts[0] : null
  }

  function getGiftHandleSet() {
    var set = Object.create(null)
    var stored = getStoredGifts()
    for (var i = 0; i < stored.length; i++) {
      var h = stored[i] && stored[i].handle
      if (typeof h === 'string' && h.length) set[h] = 1
    }
    var domHandles = readGiftHandlesFromDom()
    for (var j = 0; j < domHandles.length; j++) {
      set[domHandles[j]] = 1
    }
    for (var known in KNOWN_GIFT_HANDLES) {
      if (Object.prototype.hasOwnProperty.call(KNOWN_GIFT_HANDLES, known)) set[known] = 1
    }
    return set
  }

  function isSleepOnlyCart(cart) {
    var items = (cart && cart.items) || []
    if (!Array.isArray(items) || !items.length) return false
    var giftHandles = getGiftHandleSet()
    var hasSleep = false
    var hasOtherNonGift = false
    for (var i = 0; i < items.length; i++) {
      var item = items[i] || {}
      var qty = Number(item.quantity)
      if (!Number.isFinite(qty) || qty <= 0) continue
      var handle = typeof item.handle === 'string' ? item.handle : ''
      if (giftHandles[handle]) continue
      var pid = Number(item.product_id)
      if (pid === DEFAULT_GIFT_PRODUCT_ID) continue
      if (pid === SLEEP_PRODUCT_ID) hasSleep = true
      else hasOtherNonGift = true
    }
    return hasSleep && !hasOtherNonGift
  }

  function getCartData(cb) {
    var now = Date.now()
    if (cachedCart && now - cachedCartAt < CART_CACHE_TTL_MS) {
      cb(cachedCart)
      return
    }
    if (cartRequestInFlight) {
      cartRequestInFlight.then(cb)
      return
    }
    var root = shopRoot()
    cartRequestInFlight = fetch(root + 'cart.js')
      .then(function (r) {
        return r.ok ? r.json() : null
      })
      .catch(function () {
        return null
      })
      .then(function (cart) {
        cartRequestInFlight = null
        if (cart && cart.items) {
          cachedCart = cart
          cachedCartAt = Date.now()
        }
        return cachedCart
      })
    cartRequestInFlight.then(cb)
  }

  function dispatchCartUpdated(cart) {
    try {
      window.dispatchEvent(
        new CustomEvent('ns-cart-updated', {
          detail: { cart: cart, items: (cart && cart.items) || [] },
        })
      )
    } catch (e) {}
  }

  function syncCartNote(title) {
    var root = shopRoot()
    return fetch(root + 'cart.js')
      .then(function (r) {
        return r.json()
      })
      .then(function (cartData) {
        var lines = (cartData.note || '')
          .split('\n')
          .filter(Boolean)
          .filter(function (line) {
            return line.indexOf(NOTE_TAG) === -1
          })
        if (title) lines.push(giftNotePrefix() + ' ' + title)
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: lines.join('\n') }),
        }).then(function (res) {
          return res.json()
        })
      })
      .then(function (updatedCart) {
        if (updatedCart && updatedCart.items) dispatchCartUpdated(updatedCart)
        return updatedCart
      })
      .catch(function () {})
  }

  function renderSwap(cartData) {
    var hideSwapForSleepOnly = isSleepOnlyCart(cartData)
    getRoots().forEach(function (root) {
      var headings = root.querySelectorAll('h3')
      for (var h = 0; h < headings.length; h++) {
        var heading = headings[h]
        if (!/Your Free Gift/i.test(heading.textContent || '')) continue
        var section = heading.parentElement
        var giftLi =
          (section && section.querySelector(':scope > div > li')) ||
          (section && section.querySelector('li.relative')) ||
          (section && section.querySelector('li'))
        var outerLi = heading.closest('li')
        var itemLi = giftLi || outerLi
        var innerCol = itemLi && itemLi.querySelector('div.min-w-0')
        var titleP = innerCol && innerCol.querySelector('p.mb-1.line-clamp-2')
        var content = (titleP && titleP.parentElement) || innerCol
        if (!itemLi || !content) continue

        var swapGift = getSwapGift()
        var existingBtn = content.querySelector('[data-koh-swap-gift]') || itemLi.querySelector('[data-koh-swap-gift]')
        var primaryGift = getPrimaryGift()

        if (primaryGift) {
          var imageElInitial = itemLi.querySelector('img')
          var titleElInitial = content.querySelector('p.mb-1.line-clamp-2') || content.querySelector('p.mb-1')
          var descElInitial = content.querySelector('p.mb-2')
          if (imageElInitial && primaryGift.image) {
            imageElInitial.src = imageResizeUrl(primaryGift.image, 200, 200)
            imageElInitial.alt = primaryGift.title || 'Gift'
          }
          if (titleElInitial) titleElInitial.textContent = primaryGift.title || 'Gift'
          if (descElInitial) descElInitial.textContent = primaryGift.description || 'with subscription'
        }

        if (!swapGift || hideSwapForSleepOnly) {
          if (existingBtn) existingBtn.remove()
          continue
        }

        var label = 'SWAP FOR ' + String(swapGift.title || 'Gift').toUpperCase()
        if (existingBtn) {
          existingBtn.textContent = label
          continue
        }

        var doc = root instanceof Document ? root : root.ownerDocument
        var button = doc.createElement('button')
        button.type = 'button'
        button.setAttribute('data-koh-swap-gift', '1')
        button.className =
          'mt-2 w-full text-left text-sm font-medium uppercase underline decoration-1 underline-offset-2 xs:text-base'
        button.textContent = label
        button.addEventListener('click', function (event) {
          event.preventDefault()
          event.stopPropagation()
          var gift = getSwapGift()
          if (!gift) return
          try {
            localStorage.setItem(
              'koh_selected_gift',
              JSON.stringify({
                handle: gift.handle,
                title: gift.title,
                image: gift.image,
                description: gift.description || 'with subscription',
              })
            )
            localStorage.removeItem('koh_skip_gift')
          } catch (e) {}
          syncCartNote(gift.title || '').then(function () {
            var imageEl = itemLi.querySelector('img')
            var titleEl = content.querySelector('p.mb-1.line-clamp-2') || content.querySelector('p.mb-1')
            var descEl = content.querySelector('p.mb-2')
            if (imageEl && gift.image) {
              imageEl.src = imageResizeUrl(gift.image, 200, 200)
              imageEl.alt = gift.title || 'Gift'
            }
            if (titleEl) titleEl.textContent = gift.title || 'Gift'
            if (descEl) descEl.textContent = gift.description || 'with subscription'
            ensureGifts(function () {
              renderSwap()
            })
          })
        })
        content.appendChild(button)
      }
    })
  }

  function tick() {
    getCartData(function (cartData) {
      ensureGifts(function () {
        renderSwap(cartData)
      })
    })
  }

  function init() {
    tick()
    var body = document.body
    if (body) {
      new MutationObserver(function () {
        tick()
      }).observe(body, { childList: true, subtree: true })
    }
    function observeCart(el) {
      if (!el) return
      new MutationObserver(function () {
        if (el.shadowRoot) {
          new MutationObserver(function () {
            tick()
          }).observe(el.shadowRoot, { childList: true, subtree: true })
        }
        tick()
      }).observe(el, { childList: true, subtree: true })
    }
    observeCart(document.querySelector('ns-hybrid-cart'))
    observeCart(document.getElementById('ns-hybrid-cart'))
    observeCart(document.getElementById('ns-hybrid-cart-wrapper'))

    window.addEventListener('koh-gifts-updated', tick)
    window.addEventListener('storage', tick)
    document.addEventListener('ns-cart-updated', tick)

    setTimeout(tick, 400)
    setTimeout(tick, 1500)
    setTimeout(tick, 3500)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()
